export function* getUniqueId() {
  let id = 0;
  while (true) {
    yield ++id;
  }
}
